// Gaveta lateral do carrinho do TOTEM (o Balcão usa o painel fixo CarrinhoLateral).
import { ShoppingCart } from "lucide-react";

import ItemCarrinho from "./ItemCarrinho";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../../../components/ui/sheet";
import { fmt } from "../lib/helpers";

export default function CarrinhoSheet({ ctx }) {
  const { setScreen, cart, cartOpen, setCartOpen, cartTotal, cartCount } = ctx;
  return (<>
{/* Cart Sheet */}
<Sheet open={cartOpen} onOpenChange={setCartOpen}>
  <SheetContent side="right" className="bg-zinc-900 border-zinc-800 w-full sm:max-w-md p-0 flex flex-col">
    <SheetHeader className="p-4 border-b border-zinc-800">
      <SheetTitle className="text-zinc-100 flex items-center gap-2"><ShoppingCart className="w-5 h-5" />Carrinho ({cartCount})</SheetTitle>
    </SheetHeader>
    <div className="flex-1 overflow-y-auto p-4 space-y-3">
      {cart.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-48 text-zinc-400"><ShoppingCart className="w-12 h-12 mb-3" /><p>Carrinho vazio</p></div>
      ) : cart.map((item) => {
        return <ItemCarrinho key={item.cartItemId || item.id} item={item} ctx={ctx} />;
      })}
    </div>
    {cart.length > 0 && (
      <div className="p-4 border-t border-zinc-800 space-y-3">
        <div className="flex justify-between items-center"><span className="text-zinc-400">Total</span><span className="text-2xl font-black text-orange-500">R$ {fmt(cartTotal)}</span></div>
        <button onClick={() => { setCartOpen(false); setScreen("cart_review"); }} className="w-full h-14 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg transition-all active:scale-95">FINALIZAR PEDIDO</button>
      </div>
    )}
  </SheetContent>
</Sheet>
  </>);
}
